import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { Logo } from "../../../global";
import { PDLTypography } from "../../../dna";
import "./index.scss";

const HomeTitle = () => (
  <Container className="pdl_component_hometitle">
    <Row>
      <Col className="text-center mb-4">
        <Logo variant={"home"} />
      </Col>
    </Row>
    <Row>
      <Col className="text-center mb-4">
        <PDLTypography display size="lg">
          Bem vindo à Plataforma Lex
        </PDLTypography>
      </Col>
    </Row>
    <Row>
      <Col xs={10} className="text-center mx-auto">
        <PDLTypography size="lg">
          Conectando você às melhores soluções jurídicas, conteúdos
          especializados e tecnologia para impulsionar sua atuação profissional.
        </PDLTypography>
      </Col>
    </Row>
  </Container>
);

export default HomeTitle;
